import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { MemberCompanyModel } from 'src/app/admin-panel/models/members/member-company.model';
import { MemberCompanyService } from 'src/app/admin-panel/services/members/member-companies.service';

@Component({
  selector: 'app-details-member-company',
  templateUrl: './details-member-company.component.html',
  styleUrls: ['./details-member-company.component.scss']
})
export class DetailsMemberCompanyComponent implements OnInit {

   //#region Fields
   public unsubscribe: Subject<void> = new Subject<void>();
   public companyId: string;
   public spinner: boolean = false;
   public companyModel : MemberCompanyModel = new MemberCompanyModel();
   public imagePath: string = './assets/images/icons/profile-picture-placeholder.png'
   //#endregion
   //#region Constructor
  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    public memberCompanyService: MemberCompanyService
  ) { 
    if (this.config.data != undefined && this.config.data.id) {
      this.companyId = this.config.data.id
      this.getcompanybyid(this.companyId)
    }
  }

  ngOnInit(): void {
  }
 //#endregion
   //#region Public Methods
   getcompanybyid(id: string) {
    this.spinner = true;
    this.memberCompanyService.getcompanybyid(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;        
          this.companyModel = response;
        },
        error: errorResponse => {
          this.spinner = false;
        }
      });
  }
  cancel(){

  }
  //#endregion
}
